import { useEffect, useRef } from "react";
import posthog from "@/lib/posthog";

export function useTrackVisibility(componentName: string) {
  const ref = useRef<HTMLDivElement>(null);
  const enteredAtRef = useRef<number | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          enteredAtRef.current = Date.now();
        } else if (enteredAtRef.current !== null) {
          const duration_seconds = Math.round((Date.now() - enteredAtRef.current) / 1000);
          posthog.capture("component_viewed", { component: componentName, duration_seconds });
          enteredAtRef.current = null;
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => {
      observer.disconnect();
      if (enteredAtRef.current !== null) {
        const duration_seconds = Math.round((Date.now() - enteredAtRef.current) / 1000);
        posthog.capture("component_viewed", { component: componentName, duration_seconds });
      }
    };
  }, [componentName]);

  return ref;
}
